import { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { Row, Col, Table, Form, Button, Card } from 'react-bootstrap';
import axios from 'axios';
import { io } from 'socket.io-client';
import toast from 'react-hot-toast';
const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed

const Reports = () => {
  const [labRequests, setLabRequests] = useState([]);
  const [filters, setFilters] = useState({
    test_type: '',
    urgency: '',
    receipt_no: '',
  });
  const [reportFiles, setReportFiles] = useState({});
  const [notes, setNotes] = useState({});
  const [statusUpdates, setStatusUpdates] = useState({});
  const [showTodayOnly, setShowTodayOnly] = useState(false);

  // Fetch lab test requests with filters
  const fetchLabRequests = async (customFilters) => {
    try {
      const params = {};
      const useFilters = customFilters || filters;
      if (useFilters.test_type) params.test_type = useFilters.test_type;
      if (useFilters.urgency) params.urgency = useFilters.urgency;
      if (useFilters.receipt_no) params.receipt_no = useFilters.receipt_no;
      const res = await axios.get(`${BASE_URL}/api/lab/requests`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        params,
      });
      setLabRequests(res.data || []);
    } catch {
      setLabRequests([]);
    }
  };

  useEffect(() => {
    fetchLabRequests();
    // Real-time: connect to socket and join lab room
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user && user.role === 'Lab') {
      const socket = io(`${BASE_URL}`);
      socket.emit('joinLabRoom', user.id);

      socket.on('newLabTestRequest', (newLabTest) => {
        setLabRequests((prev) => [newLabTest, ...prev]);
      });

      // Clean up on unmount
      return () => {
        socket.disconnect();
      };
    }
    // eslint-disable-next-line
  }, []);

  // Handle filter change with instant fetch
  const handleFilterChange = (e) => {
    const newFilters = { ...filters, [e.target.name]: e.target.value };
    setFilters(newFilters);
    fetchLabRequests(newFilters);
  };

  // Handle file, note, and status changes
  const handleReportFileChange = (labTestId, file) => {
    setReportFiles((prev) => ({ ...prev, [labTestId]: file }));
  };
  const handleNoteChange = (labTestId, note) => {
    setNotes((prev) => ({ ...prev, [labTestId]: note }));
  };
  const handleStatusChange = (labTestId, status) => {
    setStatusUpdates((prev) => ({ ...prev, [labTestId]: status }));
  };

  // Update lab test (status, report, note)
  const handleUpdateLabTest = async (labTestId) => {
    const formData = new FormData();
    formData.append('lab_test_id', labTestId);
    if (statusUpdates[labTestId])
      formData.append('status', statusUpdates[labTestId]);
    if (notes[labTestId] !== undefined)
      formData.append('note', notes[labTestId]);
    if (reportFiles[labTestId])
      formData.append('report', reportFiles[labTestId]);
    try {
      await axios.post(`${BASE_URL}/api/lab/update`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success('Report upload successfully!');
      fetchLabRequests();
    } catch {
      toast.error('Failed to update lab test.');
    }
  };

  // Filtered requests for table
  const filteredLabRequests = labRequests.filter((lr) => {
    if (showTodayOnly && lr.requested_at) {
      const todayStr = new Date().toISOString().slice(0, 10);
      return lr.requested_at.slice(0, 10) === todayStr;
    }
    return true;
  });

  return (
    <Row>
      {/* <Sidebar /> */}
      <Col className="p-5">
        <h1 className="global-heading mb-3 ">Lab Report Management</h1>
        <Card className="mb-4 shadow-sm p-3">
          <Form>
            <Row className="g-3 align-items-end">
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold mb-1 primary-class" >
                    Test Type
                  </Form.Label>
                  <Form.Control
                    className="form-control"
                    placeholder="Test Type"
                    name="test_type"
                    value={filters.test_type}
                    onChange={handleFilterChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold mb-1 primary-class"  >
                    Urgency
                  </Form.Label>
                  <Form.Control
                    className="form-control"
                    placeholder="Urgency"
                    name="urgency"
                    value={filters.urgency}
                    onChange={handleFilterChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold mb-1 primary-class"  >
                    Receipt No.
                  </Form.Label>
                  <Form.Control
                    className="form-control"
                    placeholder="Receipt No."
                    name="receipt_no"
                    value={filters.receipt_no}
                    onChange={handleFilterChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="d-flex align-items-center pt-3">
                <Form.Check
                  type="checkbox"
                  label="Show only today's requests"
                  checked={showTodayOnly}
                  onChange={(e) => setShowTodayOnly(e.target.checked)}
                  className="fw-semibold mb-1 primary-class"
                   
                />
              </Col>
            </Row>
          </Form>
        </Card>
        <Card className="shadow-sm">
          <Card.Body className="p-0">
            <Table
              striped
              bordered
              hover
              size="sm"
             
            >
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Receipt No.</th>
                  <th>Patient Name</th>
                  <th>Test Type</th>
                  <th>Urgency</th>
                  <th>Status</th>
                  <th>Report</th>
                  <th>Note</th>
                  <th>Update</th>
                </tr>
              </thead>
              <tbody>
                {filteredLabRequests.map((lr, index) => (
                  <tr key={lr.id}>
                    <td data-label="Sr.No.">{index + 1}</td>
                    <td data-label="Receipt No.">{lr.receipt_no || '-'}</td>
                    <td data-label="Patient Name">{lr.patient_name || '-'}</td>
                    <td data-label="Test Type">{lr.test_type}</td>
                    <td data-label="Urgency">{lr.urgency}</td>
                    <td data-label="Status">
                      <Form.Select
                        className="form-select"
                        value={statusUpdates[lr.id] || lr.status}
                        onChange={(e) =>
                          handleStatusChange(lr.id, e.target.value)
                        }
                        size="sm"
                      >
                        <option value="Pending">Pending</option>
                        <option value="Sample Collected">
                          Sample Collected
                        </option>
                        <option value="Completed">Completed</option>
                      </Form.Select>
                    </td>
                    <td data-label="Report">
                      {lr.report ? (
                        <>
                          <a
                            href={`${BASE_URL}/api/lab/report/${lr.report}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-custom"
                            download
                            style={{ marginRight: 8 }}
                            onClick={(e) => {
                              if (
                                !window.confirm(
                                  'Do you want to download the report?',
                                )
                              ) {
                                e.preventDefault();
                              }
                            }}
                          >
                            Download
                          </a>
                          <a
                            href={`${BASE_URL}/api/lab/report/${lr.report}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-secondary"
                          >
                            View
                          </a>
                        </>
                      ) : (
                        <Form.Control
                          type="file"
                          accept="application/pdf,image/*"
                          className="form-control"
                          onChange={(e) =>
                            handleReportFileChange(lr.id, e.target.files[0])
                          }
                          size="sm"
                        />
                      )}
                    </td>
                    <td data-label="Note">
                      <Form.Control
                        as="textarea"
                        rows={1}
                        className="form-control"
                        placeholder="Add note"
                        value={
                          notes[lr.id] !== undefined
                            ? notes[lr.id]
                            : lr.notes || ''
                        }
                        onChange={(e) =>
                          handleNoteChange(lr.id, e.target.value)
                        }
                        size="sm"
                      />
                    </td>
                    <td data-label="Update">
                      <Button
                        size="sm"
                        className="btn-custom"
                        onClick={() => handleUpdateLabTest(lr.id)}
                      >
                        Update
                      </Button>
                    </td>
                  </tr>
                ))}
                {filteredLabRequests.length === 0 && (
                  <tr>
                    <td colSpan={9} className="text-center text-danger">
                      No lab test requests found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Reports;
